import { useCallback } from 'react';
import { useLocalStorage } from './use-local-storage';

export const QUICK_ACCESS_PINS_KEY = 'naia.teacher-dashboard.quick-access.pinned';
export const QUICK_ACCESS_PIN_LIMIT = 5;

export interface QuickAccessPins {
  pinned: string[];
  isPinned: (id: string) => boolean;
  atLimit: boolean;
  toggle: (id: string) => void;
}

export function useQuickAccessPins(
  defaultPinned: string[],
  storageKey: string = QUICK_ACCESS_PINS_KEY,
): QuickAccessPins {
  const [stored, setStored] = useLocalStorage<string[]>(storageKey, defaultPinned);
  const pinned = Array.isArray(stored) ? stored : defaultPinned;

  const isPinned = useCallback((id: string) => pinned.includes(id), [pinned]);

  const toggle = useCallback(
    (id: string) =>
      setStored((prev) => {
        const list = Array.isArray(prev) ? prev : [];
        if (list.includes(id)) return list.filter((x) => x !== id);
        if (list.length >= QUICK_ACCESS_PIN_LIMIT) return list;
        return [...list, id];
      }),
    [setStored],
  );

  return { pinned, isPinned, atLimit: pinned.length >= QUICK_ACCESS_PIN_LIMIT, toggle };
}
